import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { login, reset } from "../../reduxAuth/authSlice";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function AuthLogin() {
  const dispatch                                          = useDispatch();
  const { isLoading, isError, isSuccess, user, message }  = useSelector((state) => state.auth);
  const navigate                                          = useNavigate();
  
  const [formData, setFormData]                           = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    if (isError) {
      toast.error(message || "Login failed");
    }

    if (isSuccess && user) {
      toast.success("Login successful");
      navigate('/thank-you'); 
    }

    return () => dispatch(reset());
  }, [isError, isSuccess, user, message, dispatch]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { email, password } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !password) {
      toast.warning("Please fill in all fields");
      return false;
    }

    if (!emailRegex.test(email)) {
      toast.warning("Invalid email format");
      return false;
    }

    return true;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    dispatch(login(formData));
  };

  return (
     <div className="auth-layer">
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={formData.password}
              onChange={onChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-main " disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
     </div>
  )
}

export default AuthLogin